export function humbergerMenuButton(buttonEl, menuEl, closeEl) {
  if ($(buttonEl).length) {
    $(buttonEl).on("click", function () {
      $(menuEl).slideDown();
    });
  }
  if ($(closeEl).length) {
    $(closeEl).on("click", function () {
      $(menuEl).slideUp();
    });
  }
}
